var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabelM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 42,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.136 57.48C45.5173 57.9493 44.696 58.184 43.672 58.184C42.648 58.184 41.816 57.9493 41.176 57.48C40.5573 56.9893 39.96 56.1787 39.384 55.048L31.96 40.424V61.064C31.96 62.152 31.9173 62.9413 31.832 63.432C31.768 63.9227 31.608 64.4347 31.352 64.968C31.0107 65.608 30.488 66.12 29.784 66.504C29.1013 66.888 28.3333 67.08 27.48 67.08C26.6267 67.08 25.848 66.888 25.144 66.504C24.4613 66.12 23.9493 65.608 23.608 64.968C23.352 64.4347 23.1813 63.9227 23.096 63.432C23.032 62.9413 23 62.152 23 61.064V26.536C23 24.552 23.448 23.112 24.344 22.216C25.1547 21.4053 26.1573 21 27.352 21C28.3973 21 29.2827 21.2453 30.008 21.736C30.84 22.2693 31.5973 23.1867 32.28 24.488L43.672 46.184L55.064 24.488C55.7467 23.1867 56.504 22.2693 57.336 21.736C58.0613 21.2453 58.9467 21 59.992 21C61.1867 21 62.1893 21.4053 63 22.216C63.896 23.112 64.344 24.552 64.344 26.536V61.064C64.344 62.152 64.3013 62.9413 64.216 63.432C64.152 63.9227 63.992 64.4347 63.736 64.968C63.3947 65.608 62.872 66.12 62.168 66.504C61.4853 66.888 60.7173 67.08 59.864 67.08C59.0107 67.08 58.232 66.888 57.528 66.504C56.8453 66.12 56.3333 65.608 55.992 64.968C55.736 64.4347 55.5653 63.9227 55.48 63.432C55.416 62.9413 55.384 62.152 55.384 61.064V40.424L47.96 55.048C47.384 56.1787 46.776 56.9893 46.136 57.48Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelM);
export default __webpack_public_path__ + "static/media/labelM.458e640dcd2539e772b78a8abacd408d.svg";
export { ForwardRef as ReactComponent };